var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.root},[_c('portal-icon',{class:_vm.$style.icon,attrs:{"size":45,"icon":"xsolla"}}),_c('div',{class:_vm.$style.text},[_vm._v(" "+_vm._s(_vm.$t(((_vm.$appName || 'main') + ".xsolla")))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }